import ptBrTranslations from './pt-br';
import enUsTranslations from './en-us';
import esESTranslations from './es-es';

export default {
  'pt-BR': { translations: ptBrTranslations },
  'en-US': { translations: enUsTranslations },
  'es-ES': { translations: esESTranslations },
};
